<template>
    <div class="objective-form">
      <!-- Team New Okr -->
      <b-card class="shadow-none mb-1" v-if="this.type == 'Team'">
        <b-row>
          <b-col sm="12" md="6" class="px-50">
            <label class="required-field">Team</label>
            <b-button v-if="$can('Zircly Admin')"
              v-b-modal.division-modal
              size="sm"
              variant="outline-light"
              class="border-0 p-0 add-team"
              style="margin-left: 5px;"
            >
              <feather-icon
                icon="PlusCircleIcon"
                size="16"
                class="text-secondary"
            /></b-button>
            <v-select
                clas="w-100"
                v-model="objectiveData.team_name"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="teamOptions"
                :reduce="(label) => label.label"
                label="label"
                :clearable="false"
                :searchable="true"
                input-id="team_name"
                placeholder="Select Team"
              />
          </b-col>
          <b-col sm="12" md="6" class="px-50">
            <label class="required-field">OKR Owner</label>
            <v-select
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              v-model="objectiveData.okr_owner"
              :options="employeeOptions"
              class="w-100"
              :reduce="(val) => val.code"
              placeholder="Select Employee"
            />
          </b-col>
          <!-- <b-col sm="12" md="2" class="px-50">
            <label>Year</label>
            <v-select
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              v-model="objectiveData.year"
              :options="yearOptions()"
              class="w-100"
              placeholder="Select year"
            />
          </b-col> -->
          <!-- <b-col sm="12" md="2" class="px-50">
            <label>Quarter</label>
            <v-select
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              v-model="objectiveData.quarter"
              :options="quarterOptions"
              class="w-100"
              placeholder="Q1"
            /> 
          </b-col> -->
        </b-row>
      </b-card>
      <!-- End Team New Okr -->
      <!-- Organisation New Okr -->
      <b-card class="shadow-none mb-1" v-if="this.type == 'Organisation'">
        <b-row>
          <b-col sm="12" md="12" class="px-50">
            <label class="required-field">OKR Owner</label>
            <v-select
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              v-model="objectiveData.okr_owner"
              :options="employeeOptions"
              class="w-100"
              :reduce="(val) => val.code"
              placeholder="Select Employee"
            />
          </b-col>
          <!-- <b-col sm="12" md="3" class="px-50">
            <label>Year</label>
            <v-select
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :value="objectiveData.year"
              :options="yearOptions()"
              class="w-100"
              placeholder="Select year"
            />
          </b-col>
          <b-col sm="12" md="3" class="px-50">
            <label>Quarter</label>
            <v-select
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :value="objectiveData.quarter"
              :options="quarterOptions"
              class="w-100"
              placeholder="Q1"
            />
          </b-col> -->
        </b-row>
      </b-card>
      <!-- End Organisation New Okr -->
            <b-card class="shadow-none mb-0">
              <div class="object-title mb-50" v-if="objectiveData.type == 'Individual'" ><h4 class="mb-75 font-weight-bolder required-field">Your Objective & Alignment</h4></div>
              <div class="object-title mb-50" v-if="objectiveData.type == 'Team'"><h4 class="mb-75 font-weight-bolder required-field">Team Objective & Alignment</h4></div>
              <div class="object-title mb-50" v-if="objectiveData.type == 'Organisation'"><h4 class="mb-75 font-weight-bolder required-field">Organisation Objective & Alignment</h4></div>
              <div class="object-form">
                <b-input-group> 
                  <validation-provider
                    #default="{ errors }"
                    name="Objective Title"
                  >
                  <b-form-input v-model="objectiveData.title" placeholder="Objective Title"></b-form-input>
                  <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                  
                  <b-dropdown :text="objectiveData.status" variant="secondary">
                    <b-dropdown-item @click="objectiveData.status = status" v-for="status in statusOptions" >{{status}}</b-dropdown-item>
                  </b-dropdown>
                </b-input-group>
                <b-row class="mt-2" v-if="objectiveData.type != 'Organisation' ">
                  <b-col sm="6" md="4">
                    <b-form-group>
                      <v-select
                        :options="parentTypeOptions"
                        label="label"
                        :clearable="true"
                        :searchable="true"
                        input-id="parent_okr_type"
                        v-model="objectiveData.parent_objective_type"
                        name="parent_okr_type"
                        placeholder="Parent OKR Type"
                      />
                      </b-form-group>
                  </b-col>
                  <b-col sm="6" md="8" class="parent-nameokr">
                    <b-form-group>
                        <!-- <v-select
                          :options="parentOptions"
                          label="label"
                          :clearable="true"
                          :searchable="true"
                          :reduce="(val) => val.code"
                          v-model="objectiveData.parent_objective_id"
                          placeholder="Parent OKR"
                        /> -->
                      <b-dropdown variant="outline-secondary" :text="getLabel(objectiveData.parent_objective_id)" placeholder="Parent OKR" class="w-100">
                        <b-dropdown-item @click="objectiveData.parent_objective_id = parentokr.code"
                          v-for="parentokr in parentOptions">{{ parentokr.label }}</b-dropdown-item>
                      </b-dropdown>
                    </b-form-group>
                  </b-col>
                </b-row>
              </div>
            
        <div class="object-title mb-50 mt-75 list-unstyled flex align-items-center justify-content-between">
          <h4 class="font-weight-bolder required-field">Key Results</h4>
          <div class="d-flex align-items-center gap-10">
            <div class="add-result" @click="addKeyResult()">
              <a class="font-weight-bolder" variant="outline-secondary"><span class="hover-btn">Add Key Result</span></a>
            </div>
            <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none" class="delete-icon cursor-pointer" v-if="selectedKeyResults.length" @click="deleteKeyResults">
              <path d="M3.90625 5.83333H17.2396M8.90625 9.16667V14.1667M12.2396 9.16667V14.1667M4.73958 5.83333L5.57292 15.8333C5.57292 16.2754 5.74851 16.6993 6.06107 17.0118C6.37363 17.3244 6.79756 17.5 7.23958 17.5H13.9062C14.3483 17.5 14.7722 17.3244 15.0848 17.0118C15.3973 16.6993 15.5729 16.2754 15.5729 15.8333L16.4062 5.83333M8.07292 5.83333V3.33333C8.07292 3.11232 8.16071 2.90036 8.31699 2.74408C8.47327 2.5878 8.68524 2.5 8.90625 2.5H12.2396C12.4606 2.5 12.6726 2.5878 12.8288 2.74408C12.9851 2.90036 13.0729 3.11232 13.0729 3.33333V5.83333" stroke="#667085" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
        </div>
        <ul class="m-0 p-0 tree h-100">
          <li :class="(objectiveData.hashid) ? 'list-unstyled edit-okrform' : 'list-unstyled'">
            <ul class="m-0 sub-tree p-0">
              <li class="list-unstyled border-0" v-for="(key_result,k) in objectiveData.key_results" :key="k">
                <div class="shadow-none add-key pt-1 rounded mb-0 d-flex align-items-start gap-10">
                  <!-- Multiple Select and Delete -->
                  <div class="action-okr d-flex align-items-center gap-6">
                    <b-form-checkbox :id="'select-objective-'+k" :name="'key_result-'+(k+1)" 
                    v-model="selectedKeyResults" :value="k" />
                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none" class="delete-icon cursor-pointer" v-if="objectiveData.key_results.length > 1" @click="confirmDeleteKeyResult(k)">
                      <path d="M3.90625 5.83333H17.2396M8.90625 9.16667V14.1667M12.2396 9.16667V14.1667M4.73958 5.83333L5.57292 15.8333C5.57292 16.2754 5.74851 16.6993 6.06107 17.0118C6.37363 17.3244 6.79756 17.5 7.23958 17.5H13.9062C14.3483 17.5 14.7722 17.3244 15.0848 17.0118C15.3973 16.6993 15.5729 16.2754 15.5729 15.8333L16.4062 5.83333M8.07292 5.83333V3.33333C8.07292 3.11232 8.16071 2.90036 8.31699 2.74408C8.47327 2.5878 8.68524 2.5 8.90625 2.5H12.2396C12.4606 2.5 12.6726 2.5878 12.8288 2.74408C12.9851 2.90036 13.0729 3.11232 13.0729 3.33333V5.83333" stroke="#667085" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </div>
                  <!-- Multiple Select and Delete -->
                  <div class="object-form w-100">
                    <textarea
                      :id="'key_result-'+(k+1)"
                      v-model="objectiveData.key_results[k].result_description"
                      placeholder="Type measurable outcomes will you need to achieve"
                      class="w-100 form-control auto-growth"
                      rows="1"
                    ></textarea>
                    <div class="mt-75 results-bottom d-flex align-items-center justify-content-between">
                      <div class="metric-select d-md-flex align-items-center">
                        <label class="mr-75 label-size mb-0 required-field">Metric Type</label>
                        <b-form-group class="mb-0">
                          <div class="ids-btn-group d-flex align-items-center">
                            <span class="tooltip-container"  @click="objectiveData.key_results[k].metric_type = 'Percentage'">
                              <button class="group-item is-icon-only" v-b-tooltip.hover.v-default title="Percentage">
                                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                                    <g clip-path="url(#clip0_7712_58822)">
                                      <path d="M16.5 17C16.5 17.2652 16.6054 17.5196 16.7929 17.7071C16.9804 17.8946 17.2348 18 17.5 18C17.7652 18 18.0196 17.8946 18.2071 17.7071C18.3946 17.5196 18.5 17.2652 18.5 17C18.5 16.7348 18.3946 16.4804 18.2071 16.2929C18.0196 16.1054 17.7652 16 17.5 16C17.2348 16 16.9804 16.1054 16.7929 16.2929C16.6054 16.4804 16.5 16.7348 16.5 17Z" stroke="#667085" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                      <path d="M6.5 7C6.5 7.26522 6.60536 7.51957 6.79289 7.70711C6.98043 7.89464 7.23478 8 7.5 8C7.76522 8 8.01957 7.89464 8.20711 7.70711C8.39464 7.51957 8.5 7.26522 8.5 7C8.5 6.73478 8.39464 6.48043 8.20711 6.29289C8.01957 6.10536 7.76522 6 7.5 6C7.23478 6 6.98043 6.10536 6.79289 6.29289C6.60536 6.48043 6.5 6.73478 6.5 7Z" stroke="#667085" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                      <path d="M6.5 18L18.5 6" stroke="#667085" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    </g>
                                    <defs>
                                      <clipPath id="clip0_7712_58822">
                                        <rect width="24" height="24" fill="white" transform="translate(0.5)"/>
                                      </clipPath>
                                    </defs>
                                  </svg>
                              </button>
                              </span>
                            <span class="tooltip-container" @click="objectiveData.key_results[k].metric_type = 'Number'">
                              <button class="group-item is-selected" v-b-tooltip.hover.v-default title="Numeric">
                              <label class="cursor-pointer mb-0">123</label>
                              </button>
                            </span>
                              <span class="tooltip-container"  @click="objectiveData.key_results[k].metric_type = 'Boolean'">
                                <button class="group-item is-icon-only" v-b-tooltip.hover.v-default title="Yes / No">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                                    <g clip-path="url(#clip0_7712_58869)">
                                      <path d="M3.5 12C3.5 13.1819 3.73279 14.3522 4.18508 15.4442C4.63738 16.5361 5.30031 17.5282 6.13604 18.364C6.97177 19.1997 7.96392 19.8626 9.05585 20.3149C10.1478 20.7672 11.3181 21 12.5 21C13.6819 21 14.8522 20.7672 15.9442 20.3149C17.0361 19.8626 18.0282 19.1997 18.864 18.364C19.6997 17.5282 20.3626 16.5361 20.8149 15.4442C21.2672 14.3522 21.5 13.1819 21.5 12C21.5 10.8181 21.2672 9.64778 20.8149 8.55585C20.3626 7.46392 19.6997 6.47177 18.864 5.63604C18.0282 4.80031 17.0361 4.13738 15.9442 3.68508C14.8522 3.23279 13.6819 3 12.5 3C11.3181 3 10.1478 3.23279 9.05585 3.68508C7.96392 4.13738 6.97177 4.80031 6.13604 5.63604C5.30031 6.47177 4.63738 7.46392 4.18508 8.55585C3.73279 9.64778 3.5 10.8181 3.5 12Z" stroke="#667085" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                      <path d="M9.5 12L11.5 14L15.5 10" stroke="#667085" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    </g>
                                    <defs>
                                      <clipPath id="clip0_7712_58869">
                                        <rect width="24" height="24" fill="white" transform="translate(0.5)"/>
                                      </clipPath>
                                    </defs>
                                  </svg>
                                </button>
                                </span>
                              </div>
                          </b-form-group>
                        </div>
                      <div v-if="objectiveData.key_results[k].metric_type != 'Boolean'" class="startgoal d-md-flex align-items-center">
                        <label class="mr-75 mb-0 required-field">Start</label>
                        <b-form-group class="mb-0">
                          <b-form-input 
                          v-model="objectiveData.key_results[k].start" v-on:change="objectiveData.key_results[k].progress = objectiveData.key_results[k].start" />
                          <b-input-group-append is-text v-if="objectiveData.key_results[k].metric_type == 'Percentage'">
                            <feather-icon
                              icon="PercentIcon"
                              class="cursor-pointer"
                              style="color: #667085"
                            />
                          </b-input-group-append>
                          </b-form-group>
                        </div>
                      <div v-if="objectiveData.key_results[k].metric_type != 'Boolean'" class="startgoal d-md-flex align-items-center">
                        <label class="mr-75 mb-0 required-field">Goal</label>
                        <b-form-group class="mb-0">
                          <b-form-input 
                          v-model="objectiveData.key_results[k].goal"/>
                          <b-input-group-append is-text v-if="objectiveData.key_results[k].metric_type == 'Percentage'">
                            <feather-icon
                              icon="PercentIcon"
                              class="cursor-pointer"
                              style="color: #667085"
                            />
                          </b-input-group-append>
                          </b-form-group>
                        </div>
                      </div>
                  </div>
                </div>
              </li>
            </ul>
          </li>
        </ul>
      </b-card>
        <!-- Modals -->
        <b-modal
      id="division-modal"
      ref="modal"
      size="md"
      title="Submit Team Name"
      @show="resetModal"
      @hidden="resetModal"
      @ok="addDivision"
    >
      <template #modal-header="{ close }">
        <h5>Add Team Name</h5>
        <b-button size="md" variant="white" @click="close()" class="close">
          <feather-icon class="cursor-pointer" icon="XIcon" width="16px" @click="close()"/>
        </b-button>
      </template>
      <form ref="form" @submit.stop.prevent="addDivision" class="mt-1">
        <b-form-group
          label="Division Name"
          label-for="name-input"
          invalid-feedback="Name is required"
          :state="divisionNameState"
        >
          <b-form-input
            id="name-input"
            v-model="divisionName"
            :state="divisionNameState"
          ></b-form-input>
        </b-form-group>
      </form>
      <template #modal-footer="{ ok, cancel }">
        <b-button size="sm" variant="outline-secondary" @click="cancel()" class="btn ml-1 cancel-btn">
          Cancel
        </b-button>
        <b-button size="sm" variant="success" @click="ok()" class="btn yes-btn"> Save </b-button>
      </template>
    </b-modal>
        </div>
</template>
<script>
import { required, email, numeric } from "@validations";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import axios from "@axios";
export default {
  props:{
    teamOptions:{
      type:Array,
      required:true,
    },
    employeeOptions:{
      type:Array,
      required:true,
    },
    itemData:{
      required:false,
    },
    type:{
      type:String,
      required:false,
    },
    parentTypeOptions:{
      type:Array,
      required:true,
    }
  },
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      selectedKeyResults : [],
      required,
      metricTypeoptions:['Percentage', 'Number', 'Boolean'],
      statusOptions:['Upcoming','Not Started Yet', 'In Progress', 'Completed', 'Cancelled','On Hold','Deferred'],
      divisionName: null,
      divisionNameState: null,
      quarterOptions:['Q1','Q2','Q3','Q4'],
      userData: this.$cookies.get('userData'),
      parentOptions:[],
      objectiveData:{
        title:'',
        team_name:this.$cookies.get('userData').division,
        okr_owner:this.$cookies.get('userData').hashid,
        year:this.getCurrentYear(),
        quarter:this.getCurrentQuarter(),
        parent_objective_id:'',
        parent_objective_type:'',
        status:'In Progress',
        type:this.type,
        key_results:[
          {
            result_description:'',
            metric_type:'Percentage',
            start:0,
            progress:0,
            goal:100,
          }
        ]
      }
    };
  },
  methods: {
    deleteKeyResults(){
      this.objectiveData.key_results = this.objectiveData.key_results.filter((_, index) => !this.selectedKeyResults.includes(index));
      this.selectedKeyResults = []
    },
    confirmDeleteKeyResult(key) {
      this.$swal({
        title: "Are you sure?",
        text: `You want to delete Key Result #${key+1}.`,
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        customClass: {
          confirmButton: "btn btn-danger  yes-btn",
          cancelButton: "btn btn-outline-secondary ml-1 cancel-btn",
        },
        
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.removeKeyResult(key);
        }
      });
    },
    getParentObjectives(type){
      axios.get("/objectives/getList/"+type).then((res) => {
        this.parentOptions = res.data.data;
      }).catch((error) => {
        // this.$toast({
        //   component: ToastificationContent,
        //   props: {
        //     title: "Oops! Unable to fetch Parent Objectives",
        //     icon: "BellIcon",
        //     variant: "danger",
        //     text: error,
        //   },
        // });
        this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Oops! Unable to fetch Parent Objectives',
                icon: 'BellIcon',
                variant: 'danger',
                text: error,
              },
            }, {
              timeout: 2000, 
              position: 'bottom-center',
              toastClassName:"radius-8 error-info ",
              hideProgressBar : true,
            });
      });
    },
    yearOptions(){
      return ['2023','2024'];
    },
    resetModal() {
      this.divisionName = "";
    },
    addDivision() {
      const self = this;
      axios
        .post("/divisions", { name: self.divisionName })
        .then((res) => {
          // this.$toast({
          //   component: ToastificationContent,
          //   props: {
          //     title: "Division Added",
          //     icon: "BellIcon",
          //     variant: "success",
          //     text: res.data.message,
          //   },
          // });

          this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Division Added',
                icon: 'BellIcon',
                variant: 'success',
                text: res.data.message,
              },
            }, {
              timeout: 2000, 
              position: 'bottom-center',
              toastClassName:"radius-8 successful-info",
              hideProgressBar : true,
            });

          this.$emit('refresh-division', true);
        })
        .catch((error) => {
          // this.$toast({
          //   component: ToastificationContent,
          //   props: {
          //     title: "Oops! Division Adding Failed",
          //     icon: "BellIcon",
          //     variant: "danger",
          //     text: error,
          //   },
          // });
          this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Oops! Division Adding Failed',
                icon: 'BellIcon',
                variant: 'danger',
                text: error,
              },
            }, {
              timeout: 2000, 
              position: 'bottom-center',
              toastClassName:"radius-8 error-info ",
              hideProgressBar : true,
            });
        });
    },
    addKeyResult(){
      this.objectiveData.key_results.unshift({
        result_description:'',
        metric_type:'Number',
        start:0,
        progress:0,
        goal:100,
        state:''
      });
      var id = 'key_result-'+(this.objectiveData.key_results.length);
      const inputElement = document.getElementById(id);
      if (inputElement) {
        inputElement.focus();
      }
      this.$nextTick(() => {
      this.setUpTextArea();
      });
    },
    resetObjective(){
      var team = this.objectiveData.team_name;
      var okr_owner = this.objectiveData.okr_owner;
      this.objectiveData = {
        title:'',
        parent_objective_id:'',
        parent_objective_type:this.type,
        status:'In Progress',
        type:this.type,
        team_name:team,
        okr_owner:okr_owner,
        year:this.getCurrentYear(),
        quarter:this.getCurrentQuarter(),
        key_results:[
          {
            result_description:'',
            metric_type:'Number',
            start:0,
            goal:100,
            progress:0,
            state:''
          }
        ]
      };
    },
    getCurrentYear(){
      const currentDate = new Date();
      return currentDate.getFullYear();
    },
    getCurrentQuarter() {
      const currentDate = new Date();
      const currentMonth = currentDate.getMonth() + 1; // JavaScript months are 0-indexed, so add 1

      // Calculate the quarter based on the current month
      if (currentMonth >= 1 && currentMonth <= 3) {
        return 'Q1';
      } else if (currentMonth >= 4 && currentMonth <= 6) {
        return 'Q2';
      } else if (currentMonth >= 7 && currentMonth <= 9) {
        return 'Q3';
      } else {
        return 'Q4';

      }
    },
    addObjectiveToDB(action = 'create'){
      var validData = this.checkData(this.objectiveData);
      if(validData.status){
        this.$emit('objective-submitted', true);
        if(action == 'create'){
          axios.post(`objectives`, this.objectiveData)
          .then((res) => {
            if(res.data.success == false){
              this.$emit('objective-submitted', 'release');
              // this.$toast({
              //   component: ToastificationContent,
              //   props: {
              //     title: "Can't Add OKR",
              //     icon: "BellIcon",
              //     variant: "danger",
              //     text: res.data.message,
              //   },
              // });
              this.$toast({
              component: ToastificationContent,
              props: {
                title:  "Can't Add OKR",
                icon: 'BellIcon',
                variant: 'danger',
                text: res.data.message,
              },
            }, {
              timeout: 2000, 
              position: 'bottom-center',
              toastClassName:"radius-8 error-info ",
              hideProgressBar : true,
            });
              return;
            }
            this.$emit('objective-submitted', false);
            this.resetObjective();
            localStorage.removeItem('objectiveData-'+this.type);
            // this.$toast({
            //   component: ToastificationContent,
            //   props: {
            //     title: "OKR Added Successfully",
            //     icon: "BellIcon",
            //     variant: "success",
            //     text: res.data.message,
            //   },
            // });
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'OKR Added Successfully',
                icon: 'BellIcon',
                variant: 'success',
                text: res.data.message,
              },
            }, {
              timeout: 2000, 
              position: 'bottom-center',
              toastClassName:"radius-8 successful-info",
              hideProgressBar : true,
            });
          })
          .catch((error) => {
            this.$emit('objective-submitted', false);
            // this.$toast(
            //   {
            //     component: ToastificationContent,
            //     props: {
            //       title: "Oops! OKR Adding Failed",
            //       icon: "BellIcon",
            //       variant: "danger",
            //       text: error,
            //     },
            //   });
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Oops! OKR Adding Failed',
                icon: 'BellIcon',
                variant: 'danger',
                text: error,
              },
            }, {
              timeout: 2000, 
              position: 'bottom-center',
              toastClassName:"radius-8 error-info ",
              hideProgressBar : true,
            });
          });
        }else{
          axios.patch('objectives/'+this.objectiveData.hashid, this.objectiveData)
          .then((res) => {

            localStorage.removeItem('objectiveData-'+this.type);
              this.$emit('objective-submitted', false);
              // this.$toast({
              //   component: ToastificationContent,
              //   props: {
              //     title: "OKR Updated Successfully",
              //     icon: "BellIcon",
              //     variant: "success",
              //     text: res.data.message,
              //   },
              // });
              this.$toast({
              component: ToastificationContent,
              props: {
                title: 'OKR Updated Successfully',
                icon: 'BellIcon',
                variant: 'success',
                text: res.data.message,
              },
            }, {
              timeout: 2000, 
              position: 'bottom-center',
              toastClassName:"radius-8 successful-info",
              hideProgressBar : true,
            });
          })
          .catch((error) => {
            // this.$toast(
            //   {
            //     component: ToastificationContent,
            //     props: {
            //       title: "Oops! OKR Adding Failed",
            //       icon: "BellIcon",
            //       variant: "danger",
            //       text: error,
            //     },
            //   });
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Oops! OKR Adding Failed',
                icon: 'BellIcon',
                variant: 'danger',
                text: error,
              },
            }, {
              timeout: 2000, 
              position: 'bottom-center',
              toastClassName:"radius-8 error-info ",
              hideProgressBar : true,
            });
          });
        }
      }
      else{
        for(var key in validData.messages){
        //  this.$toast(
        //     {
        //       component: ToastificationContent,
        //       props: {
        //         title: validData.messages[key].title,
        //         text:validData.messages[key].text,
        //         icon: "BellIcon",
        //         variant: "danger",
        //       },
        //     }); 

        this.$toast({
              component: ToastificationContent,
              props: {
                title: validData.messages[key].title,
                icon: 'BellIcon',
                variant: 'danger',
                text: validData.messages[key].text,
              },
            }, {
              timeout: 2000, 
              position: 'bottom-center',
              toastClassName:"radius-8 error-info ",
              hideProgressBar : true,
            });
        }
      }

    },
    addObjective(objective){
      delete objective["hashid"];
      this.objectiveData = objective;
      this.addObjectiveToDB();
      this.resetObjective();
    },
    checkData(objectiveData) {
      var messages = [];
      if (objectiveData.title == ''){
        messages.push({'title':'Objective title is required','text':'Please enter objective title.'});       
      }
      // if (objectiveData.type != 'individual'){
      //   messages.push({'title':'Objective title is required','text':'Please enter objective title.'});       
      // }
      objectiveData.key_results.forEach(function(key_result,key) { 
        if(key_result.result_description == '' || key_result.result_description == null ){
          messages.push({'title':"Key Result is required #"+(key+1),'text':"Please Enter Key Result #"+(key+1)+" for Objective "});
        }
        if(key_result.metric_type == 'Number' || key_result.metric_type == 'Percentage' ){
          if(key_result.goal == '' || key_result.goal == null || key_result.goal == 0 || !(!isNaN(key_result.goal) && !isNaN(parseInt(key_result.goal)))){
            messages.push({'title':"Goal "+key_result.metric_type+" is required #"+(key+1),'text':"Please Valid Enter Goal "+key_result.metric_type+" for Key Result #"+(key+1)});
          }
          if((key_result.start < 0 || key_result.start == '' || key_result.start == null  || !(!isNaN(key_result.start) && !isNaN(parseInt(key_result.start))))){
            if(key_result.start != 0){
              if(key_result.start < 0){
                messages.push({'title':"Start "+key_result.metric_type+" is invalid #"+(key+1),'text':"Start "+key_result.metric_type+ "must be zero or positive for Key Result #"+(key+1)});
              }else{
                messages.push({'title':"Start "+key_result.metric_type+" is required #"+(key+1),'text':"Please Enter Valid Start for Key Result #"+(key+1)});
              }
            }
          }
          if(parseInt(key_result.start) >= parseInt(key_result.goal)){
            messages.push({'title':"Start "+key_result.metric_type+" is required #"+(key+1),'text':"Start must be less than Target for Key Result #"+(key+1)});
          }
          if(key_result.progress && parseInt(key_result.progress) < parseInt(key_result.start)){
            messages.push({'title':"Progress "+key_result.metric_type+" is not valid for #"+(key+1),'text':"Progress must be grater than Start for Key Result #"+(key+1)});
          }
          
        }
      });

      var response = {"status":false,'messages':messages};
      if(messages.length == 0){
        var response = {"status":true,'messages':messages};
      }
      return response;      
    },
    getLabel(code){
      if(code){
        return this.parentOptions.find(parentOkr => parentOkr.code === code).label;
      }
      else {
        return 'Parent OKR';
      }
    },
    removeKeyResult(key){
      this.objectiveData.key_results.splice(key, 1)
    },
    setUpTextArea(){
      // Auto growth textarea
      var textareas =  document.getElementsByClassName('auto-growth');
      // Loop through the elements and perform some action
      for (var i = 0; i < textareas.length; i++) {
          var textarea = textareas[i];
          textarea.addEventListener('keydown', autosize);
            function autosize(){
              var el = this;
              setTimeout(function(){
                el.style.cssText = 'height:auto; padding:0';
                el.style.cssText = 'height:' + el.scrollHeight + 'px';
              },0);
            }
          // End Auto growth textarea
      }
      
    }
  },
  created() {
    if(this.objectiveData.parent_objective_type){
    this.getParentObjectives(this.objectiveData.parent_objective_type);
    }else{
    this.getParentObjectives(this.type);
    }
    const savedData = localStorage.getItem('objectiveData-'+this.type);
    if (savedData) {
      this.objectiveData = JSON.parse(savedData);
    }

    localStorage.removeItem('objectiveData-'+this.type);
  },
  watch: {
    'objectiveData.parent_objective_type': function(newValue, oldValue) {
      this.objectiveData.parent_objective_id = '';
      this.getParentObjectives(newValue);
    },
    objectiveData: {
      handler(newData) {
        // Save form data to localStorage on every change
        localStorage.setItem('objectiveData-'+this.type, JSON.stringify(newData));
      },
      deep: true // Enable deep watching to detect changes in nested properties
    }
  },
  mounted() {
    if(this.itemData){
      this.objectiveData = this.itemData;
    }
    this.setUpTextArea();
    
  },
}
</script>